import React, { createContext, useContext } from 'react'

const CarCasesBadgeContext = createContext({
    count: 0,
    loading: true,
    refresh: () => {},
})

export const useCarCasesBadgeRefresh = () => {
    const context = useContext(CarCasesBadgeContext)
    return context.refresh
}

export const useCarCasesBadgeContext = () => {
    return useContext(CarCasesBadgeContext)
}

export const CarCasesBadgeProvider = ({ children, count, loading, refresh }) => {
    return (
        <CarCasesBadgeContext.Provider value={{ count, loading, refresh }}>
            {children}
        </CarCasesBadgeContext.Provider>
    )
}

export default CarCasesBadgeContext

